"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/search/v1/legacy_portal_common.proto (package spwn.search.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalSearchResultGoods = exports.Part = exports.LegacyPortalSearchResultEvent = exports.LegacyPortalSearchAvailabilityStatus = exports.LegacyPortalSearchEventType = exports.LegacyPortalSearchResultLabel = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.search.v1.LegacyPortalSearchResultLabel
 */
var LegacyPortalSearchResultLabel;
(function (LegacyPortalSearchResultLabel) {
    /**
     * @generated from enum value: LEGACY_PORTAL_SEARCH_RESULT_LABEL_UNSPECIFIED = 0;
     */
    LegacyPortalSearchResultLabel[LegacyPortalSearchResultLabel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 算出前提条件が揃わずラベル算出不可な場合
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_RESULT_LABEL_NONE = 1;
     */
    LegacyPortalSearchResultLabel[LegacyPortalSearchResultLabel["NONE"] = 1] = "NONE";
    /**
     * 販売期間前
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_RESULT_LABEL_BEFORE_SALE = 2;
     */
    LegacyPortalSearchResultLabel[LegacyPortalSearchResultLabel["BEFORE_SALE"] = 2] = "BEFORE_SALE";
    /**
     * 販売中
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_RESULT_LABEL_ON_SALE = 3;
     */
    LegacyPortalSearchResultLabel[LegacyPortalSearchResultLabel["ON_SALE"] = 3] = "ON_SALE";
    /**
     * 販売終了
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_RESULT_LABEL_END = 4;
     */
    LegacyPortalSearchResultLabel[LegacyPortalSearchResultLabel["END"] = 4] = "END";
    /**
     * 残りわずか
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_RESULT_LABEL_A_FEW_LEFT = 5;
     */
    LegacyPortalSearchResultLabel[LegacyPortalSearchResultLabel["A_FEW_LEFT"] = 5] = "A_FEW_LEFT";
    /**
     * SOLD OUT
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_RESULT_LABEL_SOLD_OUT = 6;
     */
    LegacyPortalSearchResultLabel[LegacyPortalSearchResultLabel["SOLD_OUT"] = 6] = "SOLD_OUT";
    /**
     * NEW
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_RESULT_LABEL_NEW = 7;
     */
    LegacyPortalSearchResultLabel[LegacyPortalSearchResultLabel["NEW"] = 7] = "NEW";
})(LegacyPortalSearchResultLabel = exports.LegacyPortalSearchResultLabel || (exports.LegacyPortalSearchResultLabel = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalSearchResultLabel)
protobuf_1.proto3.util.setEnumType(LegacyPortalSearchResultLabel, "spwn.search.v1.LegacyPortalSearchResultLabel", [
    { no: 0, name: "LEGACY_PORTAL_SEARCH_RESULT_LABEL_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_SEARCH_RESULT_LABEL_NONE" },
    { no: 2, name: "LEGACY_PORTAL_SEARCH_RESULT_LABEL_BEFORE_SALE" },
    { no: 3, name: "LEGACY_PORTAL_SEARCH_RESULT_LABEL_ON_SALE" },
    { no: 4, name: "LEGACY_PORTAL_SEARCH_RESULT_LABEL_END" },
    { no: 5, name: "LEGACY_PORTAL_SEARCH_RESULT_LABEL_A_FEW_LEFT" },
    { no: 6, name: "LEGACY_PORTAL_SEARCH_RESULT_LABEL_SOLD_OUT" },
    { no: 7, name: "LEGACY_PORTAL_SEARCH_RESULT_LABEL_NEW" },
]);
/**
 * 種別
 *
 * @generated from enum spwn.search.v1.LegacyPortalSearchEventType
 */
var LegacyPortalSearchEventType;
(function (LegacyPortalSearchEventType) {
    /**
     * @generated from enum value: LEGACY_PORTAL_SEARCH_EVENT_TYPE_UNSPECIFIED = 0;
     */
    LegacyPortalSearchEventType[LegacyPortalSearchEventType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 公演
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_EVENT_TYPE_VENUE = 1;
     */
    LegacyPortalSearchEventType[LegacyPortalSearchEventType["VENUE"] = 1] = "VENUE";
    /**
     * 配信
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_EVENT_TYPE_STREAMING = 2;
     */
    LegacyPortalSearchEventType[LegacyPortalSearchEventType["STREAMING"] = 2] = "STREAMING";
})(LegacyPortalSearchEventType = exports.LegacyPortalSearchEventType || (exports.LegacyPortalSearchEventType = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalSearchEventType)
protobuf_1.proto3.util.setEnumType(LegacyPortalSearchEventType, "spwn.search.v1.LegacyPortalSearchEventType", [
    { no: 0, name: "LEGACY_PORTAL_SEARCH_EVENT_TYPE_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_SEARCH_EVENT_TYPE_VENUE" },
    { no: 2, name: "LEGACY_PORTAL_SEARCH_EVENT_TYPE_STREAMING" },
]);
/**
 * 受付ステータス
 *
 * @generated from enum spwn.search.v1.LegacyPortalSearchAvailabilityStatus
 */
var LegacyPortalSearchAvailabilityStatus;
(function (LegacyPortalSearchAvailabilityStatus) {
    /**
     * @generated from enum value: LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalSearchAvailabilityStatus[LegacyPortalSearchAvailabilityStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 販売前
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_BEFORE_SALE = 1;
     */
    LegacyPortalSearchAvailabilityStatus[LegacyPortalSearchAvailabilityStatus["BEFORE_SALE"] = 1] = "BEFORE_SALE";
    /**
     * 販売中
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_ON_SALE = 2;
     */
    LegacyPortalSearchAvailabilityStatus[LegacyPortalSearchAvailabilityStatus["ON_SALE"] = 2] = "ON_SALE";
    /**
     * 販売終了
     *
     * @generated from enum value: LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_SALE_ENDED = 3;
     */
    LegacyPortalSearchAvailabilityStatus[LegacyPortalSearchAvailabilityStatus["SALE_ENDED"] = 3] = "SALE_ENDED";
})(LegacyPortalSearchAvailabilityStatus = exports.LegacyPortalSearchAvailabilityStatus || (exports.LegacyPortalSearchAvailabilityStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalSearchAvailabilityStatus)
protobuf_1.proto3.util.setEnumType(LegacyPortalSearchAvailabilityStatus, "spwn.search.v1.LegacyPortalSearchAvailabilityStatus", [
    { no: 0, name: "LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_BEFORE_SALE" },
    { no: 2, name: "LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_ON_SALE" },
    { no: 3, name: "LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_SALE_ENDED" },
]);
/**
 * イベント情報
 *
 * @generated from message spwn.search.v1.LegacyPortalSearchResultEvent
 */
class LegacyPortalSearchResultEvent extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * イベントタイトル
         *
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * バナー画像
         *
         * @generated from field: string event_banner = 3;
         */
        this.eventBanner = "";
        /**
         * デフォルト画像
         *
         * @generated from field: string default_image = 4;
         */
        this.defaultImage = "";
        /**
         * 配信開始日時 unixTime
         *
         * @generated from field: int64 event_start_time = 5;
         */
        this.eventStartTime = protobuf_1.protoInt64.zero;
        /**
         * 配信終了日時 unixTime
         *
         * @generated from field: int64 event_end_time = 6;
         */
        this.eventEndTime = protobuf_1.protoInt64.zero;
        /**
         * イベントパート
         *
         * @generated from field: repeated spwn.search.v1.Part parts = 7;
         */
        this.parts = [];
        /**
         * 終了フラグ
         *
         * @generated from field: bool is_closed = 8;
         */
        this.isClosed = false;
        /**
         * アーティスト
         *
         * @generated from field: repeated string artists = 9;
         */
        this.artists = [];
        /**
         * 販売状況表示用ラベル
         *
         * @generated from field: spwn.search.v1.LegacyPortalSearchResultLabel label = 10;
         */
        this.label = LegacyPortalSearchResultLabel.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalSearchResultEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalSearchResultEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalSearchResultEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalSearchResultEvent, a, b);
    }
}
exports.LegacyPortalSearchResultEvent = LegacyPortalSearchResultEvent;
LegacyPortalSearchResultEvent.runtime = protobuf_1.proto3;
LegacyPortalSearchResultEvent.typeName = "spwn.search.v1.LegacyPortalSearchResultEvent";
LegacyPortalSearchResultEvent.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_banner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "default_image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "event_start_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "event_end_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "parts", kind: "message", T: Part, repeated: true },
    { no: 8, name: "is_closed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "artists", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "label", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalSearchResultLabel) },
]);
/**
 * イベントパート
 *
 * @generated from message spwn.search.v1.Part
 */
class Part extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: int64 open_time = 2;
         */
        this.openTime = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 start_time = 3;
         */
        this.startTime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Part().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Part().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Part().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Part, a, b);
    }
}
exports.Part = Part;
Part.runtime = protobuf_1.proto3;
Part.typeName = "spwn.search.v1.Part";
Part.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "open_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "start_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.search.v1.LegacyPortalSearchResultGoods
 */
class LegacyPortalSearchResultGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズID
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * 商品名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * サムネイル画像URL
         *
         * @generated from field: string thumbnail = 3;
         */
        this.thumbnail = "";
        /**
         * 価格（円）
         *
         * @generated from field: int32 price_jpy = 4;
         */
        this.priceJpy = 0;
        /**
         * 販売元(イベント名やアーティスト名や事務所名など)
         *
         * @generated from field: string seller = 5;
         */
        this.seller = "";
        /**
         * 販売状況ラベル
         *
         * @generated from field: spwn.search.v1.LegacyPortalSearchResultLabel status = 6;
         */
        this.status = LegacyPortalSearchResultLabel.UNSPECIFIED;
        /**
         * portalグッズ詳細ページ相対URL
         *
         * @generated from field: string relative_goods_url = 7;
         */
        this.relativeGoodsUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalSearchResultGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalSearchResultGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalSearchResultGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalSearchResultGoods, a, b);
    }
}
exports.LegacyPortalSearchResultGoods = LegacyPortalSearchResultGoods;
LegacyPortalSearchResultGoods.runtime = protobuf_1.proto3;
LegacyPortalSearchResultGoods.typeName = "spwn.search.v1.LegacyPortalSearchResultGoods";
LegacyPortalSearchResultGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price_jpy", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "seller", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalSearchResultLabel) },
    { no: 7, name: "relative_goods_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map